import React from "react";
import { FormControl, Select, InputLabel, Grid } from "material-ui";
import { InputAdornment } from "material-ui/Input";
import { WrappedFieldProps } from "redux-form";
import LensIcon from "material-ui-icons/Lens";

interface OwnProps {
    id?: string;
    label?: string;
    name?: string;
    className?: string;
    options?: any;
    useAriaLabel?: boolean;
    renderEmptyCellItem?: boolean;
    required?: boolean;
    adornment?: string;
    onChangeCapture?: () => {};
}

type Props = OwnProps & WrappedFieldProps;
/**
 * @component This component replaces RenderSelectField.tsx and is intented fulfill WCAG 2.1 requirements
 * @usage Works well with Field-component from redux-form.
 */
const renderCustomSelectField = ({
    id,
    input,
    label,
    meta,
    options,
    name,
    className,
    useAriaLabel,
    renderEmptyCellItem = false,
    required,
    adornment,
    ...custom
}: Props) => {
    const errorClass = meta.touched && meta.error ? " error" : "";
    let optionCells: JSX.Element[] = [];
    renderEmptyCellItem &&
        optionCells.push(
            <option key={""} value={""}>
                {""}
            </option>
        );
    options &&
        options.forEach((element: any) => {
            const dis = element.header ? true : false;

            const cell = (
                <option
                    disabled={dis}
                    key={element.value}
                    value={element.value}
                >
                    {element.label}
                </option>
            );

            optionCells.push(cell);
        });
    const inputProps = useAriaLabel
        ? {
              name: name,
              id: id,
              "aria-label": id,
          }
        : { name: name, id: id };
    return (
        <FormControl
            error={meta.touched && meta.error}
            style={{ width: "100%" }}
        >
            <Select
                native
                {...input}
                {...custom}
                onChangeCapture={custom.onChangeCapture}
                className={className}
                inputProps={inputProps}
                endAdornment={
                    adornment && (
                        <InputAdornment position="end">
                            <span tabIndex={0} style={{ fontWeight: 600 }}>
                                {adornment}
                            </span>
                        </InputAdornment>
                    )
                }
            >
                {optionCells}
            </Select>
            <label htmlFor={id}>
                {label}
                {required && (
                    <span>
                        <LensIcon
                            className={"hypo-lens-icon lens-icon" + errorClass}
                        />{" "}
                        <br />
                        <span style={{ color: "red" }} tabIndex={0}>
                            {meta.touched && meta.error}
                        </span>
                    </span>
                )}
            </label>
        </FormControl>
    );
};

export default renderCustomSelectField;



// WEBPACK FOOTER //
// ./src/components/form/RenderCustomSelectField.tsx